import React, { useContext } from "react";

import ReactDOM from "react-dom";
import { useParams } from "react-router-dom";

import {
	LookupContext,
	OfferOptionsContext,
	OfferStoreContext,
} from "@gp/components";
import { PeriodConverter } from "@state";
import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";
import useAdditionalOffer from "@state/hooks/offer/additional-offer/useAdditionalOffer";
import { observer } from "mobx-react";

import { AdditionalOfferCore } from ".";

const AdditionalOffer = observer(function AdditionalOffer(props: {
	type?: "prematch" | "live";
}) {
	const parentOfferStore = useContext(OfferStoreContext);
	const favoritesStore = useContext(FavoritesStoreContext);
	const params = useParams<{ period: string }>();
	const { viewStore, isThereOfferToDisplay, containerElement } =
		useAdditionalOffer({
			type: props.type,
			parentOfferStore,
			favoritesStore,
		});

	if (!isThereOfferToDisplay || containerElement == null) {
		return null;
	}

	const options = {
		isOfferHistory: viewStore.isOfferHistory,
		isHistoryEvent: (id: string) => viewStore.isHistoryEvent(id),
	};

	return ReactDOM.createPortal(
		<OfferStoreContext.Provider value={viewStore}>
			<LookupContext.Provider value={viewStore.lookupsStore}>
				{/* @ts-expect-error */}
				<OfferOptionsContext.Provider value={options}>
					<AdditionalOfferCore store={viewStore} />
				</OfferOptionsContext.Provider>
			</LookupContext.Provider>
		</OfferStoreContext.Provider>,
		containerElement
	);
});

export default AdditionalOffer;
